import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'MouseSelection',
  props: {
  top: {
    type: Number,
    required: true,
  },
  left: {
    type: Number,
    required: true,
  },
  width: {
    type: Number,
    required: true,
  },
  height: {
    type: Number,
    required: true,
  },
  quadrant: {
    type: Number,
    required: true,
    validator(value: number) {
      return [1, 2, 3, 4].includes(value)
    },
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`mouse-selection quadrant-${__props.quadrant}`),
    style: _normalizeStyle({
      top: __props.top + 'px',
      left: __props.left + 'px',
      width: __props.width + 'px',
      height: __props.height + 'px',
    })
  }, null, 6))
}
}

})